export const SSO_LOGIN_URL = '/api/v1/login';
export const LOGIN_URL = '/api/v1/user_login';
export const EXTERNAL_LOGIN_URL = '/api/v1/external_login?email=';
export const OTP_VERIFICATION_URL = '/api/v1/otp_verification?email=';
export const LOGOUT_URL = '/api/v1/user_logout';
export const SSO_LOGOUT_URL = '/api/v1/logout';
export const EVENT_LIST_URL = '/api/v1/workflow_instance/';
export const NEW_EVENT_LIST_URL = '/api/v2/list_details';
export const WORKFLOW_URL = '/api/v1/workflow';
export const SCHEMA_URL = '/api/v1/schema';
export const SCHEMA_DETAIL_URL = '/api/v1/schema/';
export const CREATE_EVENT_URL = `/api/v2/workflow/`;
export const CREATE_MICE_URL = '/api/v2/workflow/';
export const EVENT_DETAILS_URL = '/api/v1/workflow_instance/detail/';
export const UPLOAD_FILE_URL = '/api/v1/upload_file';
export const UPDATE_WORKFLOW_URL = '/api/v2/workflow/';
export const GET_IMAGES_URL = '/api/v1/workflow_instance/';
export const GET_NOTIFICATION_URL = '/api/v1/notification';
export const SEND_NOTIFICATION_URL = '/api/v1/notification';
export const GET_TRAVEL_PARTNERS_URL = '/api/v1/get_travel_partners';
export const GET_TRAVEL_PARTNERS_BLOCK_LIST =
  '/api/v1/travel_partners_blocked_list';
export const GET_QUICKLINK_IMAGES_REVIEWS_URL = '/api/v1/get_images_reviews';
export const GET_QUICKLINK_WALLET_URL = '/api/v1/getWallet';
export const UPLOAD_QUICKLINK_WALLET_URL = '/api/v1/uploadWallet';
export const GET_POLICY_DOCS_URL = '/api/v1/get_policies_documents';
export const APPROVED_IMAGES_URL = '/api/v1/get_approved_images?event_id=';
export const USER_IMAGES_CARD_URL = '/api/v1/getUserCard?event_id=';
export const READ_ALL_NOTIFICATION_URL = '/api/v1/update_notification';
export const UPLOAD_EVENT_FILE =
  '/api/v1/update_files_workflow_instance?workflow_instance_id=';
export const REVIEW_DETAILS = '/api/v1/get_review_details?event_id=';
export const DELETE_IMAGES_PERMANENTLY = '/api/v1/delete_images';
export const USER_IMAGE_UNDER_REVIEW_CARDS_URL =
  '/api/v1/get_user_images?event_id=';
export const GET_PACKAGES_LISTING_URL = '/api/v1/get_package';
export const ADD_PACKAGE_URL = '/api/v1/add_package';
export const UPLOAD_PACKAGE_URL = '/api/v1/update_package?package_id=';
export const APPROVE_PACKAGES_URL = '/api/v1/approve_package';
export const DELETE_PACKAGES_URL = '/api/v1/delete_packages';
export const VENDOR_EVENT_LIST = '/api/v2/vendor_list_details?type=';
export const VENDOR_DOC_URL = `/api/v2/workflow/`;
export const GRAPH_URL = '/api/v1/mis_event';
export const MICE_GRAPH_URL = '/api/v1/mis_mice';
export const VENDOR_MIS_UPLOAD_URL = '/api/v1/uploadFileMis';
export const VENDOR_EXPENSE_LISTING = '/api/v1/expense_listing';
export const VENDOR_DELETE_EXPENSE = '/api/v1/delete_expense';
export const EVENT_CHECK_URL = '/api/v1/check_event_name?event_name=';
export const USER_INFORMATION = '/api/v1/get_user_details';
export const CHECK_ATTENDEES_UPLOAD = '/api/v2/excel_validation';
export const ADD_NEW_TRAVEL_PARTNERS = '/api/v2/add_travel_partners';
export const EDIT_TRAVEL_PARTNERS = '/api/v1/edit_travel_partners';
export const DELETE_TRAVEL_PARTNERS = '/api/v1/delete_travel_partners';
export const ADD_HOTEL_DETAILS = '/api/v2/add_hotel_details';
export const EDIT_HOTEL_DETAILS = '/api/v1/edit_hotel_details';
export const DELETE_HOTEL_DETAILS = '/api/v1/delete_hotel';
export const GET_HOTEL_DETAILS = '/api/v1/get_hotel_list';
export const BULK_UPLOAD_HOTEL_DETAILS = '/api/v2/add_hotel_details';
export const UPLOAD_MENU_URL = '/api/v2/upload_menu';
export const GET_FOOD_MENU_URL = '/api/v1/get_food_menu';
export const UPDATE_FOOD_MENU_STATUS = '/api/v1/update_menu_date_status';
export const DOWNLOAD_REVIEW_REPORT = '/api/v1/download_review_excel';
export const GET_QUIZ = '/api/v1/quizzes';
export const DELETE_EVENT_DETAILS = '/api/v1/delete_event_details';
export const DELETE_IMAGE_REVIEW = '/api/v1/delete_image_review';
export const HOTEL_EMAIL_ENQUIRY = '/api/v1/hotel_email_enquiry';
export const USER_LISTING = '/api/v1/user';
export const USER_ACCESS_REQUESTS_LISTING = '/api/v1/event/requested_users';
export const USER_ACCESS_REQUESTS_UPDATE = '/api/v1/event/access_update';
export const USER_ACCESS_REQUESTS = '/api/v2/event/request_access';
export const CHECK_EVENT_COORDINATOR = '/api/v1/check_event_coordinator';
export const CREATE_SURVEY_FORM = '/api/v1/create_survey_form';
export const EDIT_SURVEY_FORM = '/api/v1/edit_survey_form';
export const GET_SURVEY_FORM_DETAILS = '/api/v1/get_survey_forms';
export const GET_SURVEY_FORM_DETAILS_BY_ID = '/api/v1/get_survey_form';
export const SUBMIT_SURVEY_FORM = '/api/v1/submit_survey_response';
export const GET_SURVEY_FORM_RESPONSES = '/api/v1/get_survey_responses';
export const GET_EVENT_USER_REQUESTS_STATUS = '/api/v1/event/request_status';
export const EXECUTE_COST_BENCHMARK = '/api/v1/execute_cost_benchmark';
export const GET_COST_BENCHMARKING_DATA = '/api/v4/quotation_cost_benchmarking';
export const GET_BENCHMARK_DATA = '/api/v1/get_master_benchmark';
export const EDIT_BENCHMARK_DATA = '/api/v1/edit_master_benchmark';
export const ADD_EVENT_SESSION = '/api/v1/event_session';
export const EDIT_EVENT_SESSION = '/api/v1/event_session';
export const GET_EVENT_SESSIONS = '/api/v1/event_sessions';
export const DELETE_EVENT_SESSION = '/api/v1/delete_event_sessions';
export const DELETE_WALLET = '/api/v1/deleteWallet';
export const DOWNLOAD_SURVEY_REPORT = '/api/v1/generate_survey_report';
export const GET_DELETED_EVENTS = '/api/v1/get_deleted_events';
export const GET_QUOTATION_REQUESTS = '/api/v1/admin/edit-requests';
export const APPROVE_QUOTATION_REQUEST = '/api/v1/admin/approve-request';
export const UPLOAD_QUOTATION = '/api/v1/quotations';
export const EDIT_QUOTATION = '/api/v1/edit_quotation';
export const DELETE_QUOTATION = '/api/v1/delete_quotation';
export const LIST_QUOTATIONS = '/api/v1/list_quotations';
export const REQUEST_EDIT_QUOTATION = '/api/v1/request-edit';
export const QUOTATION_ANALYSIS = '/api/v2/quotation_analysis';
export const EDIT_BENCHMARK = '/api/v1/edit_benchmark_data';
export const UPDATE_BENCHMARK_FROM_INVOICE = '/api/v1/update_benchmark_price_from_invoice'